import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Fee }              from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "FEE_LOADING" });
    },

    /**
     * Fetches the Fee List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Fee.getAll(params);
        data.sort = params;
        dispatch({ type : "FEE_LIST", data });
    },

    /**
     * Fetches a single Fee
     * @param {Function} dispatch
     * @param {Number}   feeID
     * @returns {Promise}
     */
    async fetchElem(dispatch, feeID) {
        const data = await Fee.getOne({ feeID });
        dispatch({ type : "FEE_ELEM", data });
    },

    /**
     * Fetches the Fee Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Fee.getEditData();
        dispatch({ type : "FEE_EDIT", data });
    },

    /**
     * Edits/Creates a Fee
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Fee.edit(data);
    },

    /**
     * Deletes a Fee
     * @param {Function} dispatch
     * @param {Number}   feeID
     * @returns {Promise}
     */
    deleteElem(dispatch, feeID) {
        return Fee.delete({ feeID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "FEE_LIST", "FEE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "FEE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "FEE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "FEE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            statuses  : action.data.statuses,
        };

    case "FEE_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
